<template>
  <v-flex xs12 class="my-4">
    <InvoiceFilter @fetch="fetch"></InvoiceFilter>

    <v-data-table class="elevation-1"
      :headers="headers"
      :items="items"
      :loading="loading"
      :total-items="totalItems"
      :pagination.sync="pagination"
      :no-data-text="$t('noGeneratedInvoices')">
      <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
      <template v-slot:items="{ item }">
        <tr>
          <td>
            <span v-if="item.hs_transaction">
              {{ item.hs_transaction.amount | currency }}
            </span>
          </td>
          <td>
            <span v-if="item.hs_transaction">
              {{ item.hs_transaction.sequential_id || item.hs_transaction.id }}
            </span>
          </td>
          <td v-if="!$auth.isCust()">
            <span v-if="item.hs_transaction && item.hs_transaction.user">
              {{ item.hs_transaction.user.sequential_id || item.hs_transaction.user.id }}
              /
              {{ item.hs_transaction.user.name }}
              {{ item.hs_transaction.user.last_name }}
            </span>
          </td>
          <td> {{ item.created_at | date('lll') }} </td>
          <td> {{ $t(`list.statuses.${item.status}_f`) }} </td>
          <td>
            <v-btn elevation="2" outline color="success" @click="downloadInvocie(item)">{{ $t('download') }}</v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-flex>
</template>

<script>
import { mapGetters } from 'vuex'

import Invoice from '@/client/invoice'

import InvoiceFilter from '@/components/invoices/filter'

export default {
  name: "GeneratedInvoicesComp",

  data () {
    return {
      items: [],
      totalItems: 0,
      pagination: {
        rowsPerPage: 10,
        sortBy: 'created_at',
        descending: true
      },
      transaction_id: '',
      user_id: '',
      loading: false,
      params: {}
    }
  },

  props: {
  },

  components: {
    InvoiceFilter
  },

  computed: {
    ...mapGetters(['invoicesToken']),

    headers () {
      let h = [
        { text: this.$t('attrs.amount'), align: 'left', sortable: true, value: 'hs_transaction.amount' },
        { text: this.$tc('models.transaction'), align: 'left', sortable: true, value: 'hs_transaction.id' },
      ]

      if (!this.$auth.isCust()) {
        h.push({ text: this.$tc('models.user'), align: 'left', sortable: true, value: 'hs_transaction.user.name' })
      }
      return h.concat([
        { text: this.$t('attrs.created_at'), align: 'left', sortable: true, value: 'created_at' },
        { text: this.$t('attrs.status'), align: 'left', sortable: true, value: 'status' },
        { text: '', align: 'right', sortable: false, value: 'actions' }
      ])
    },
  },

  methods: {
    async fetch (params = {}, filter = false) {
      this.loading = true
      const { sortBy, descending, page, rowsPerPage } = this.pagination
      let order = ''
      if (sortBy) {
        order = `${sortBy} ${descending ? 'desc' : 'asc'}`
      }

      if (filter) this.params = params

      let obj = {
        page,
        per_page: rowsPerPage,
        order,
        where: {
          status: 'generated'
        }
      }
      if (this.transaction_id) { obj.where.transaction_id = this.transaction_id }
      if (this.user_id) { obj.where.user_id = this.user_id }

      // filter params
      if (this.params.email) { obj.where.users = {email: this.params.email} }
      if (this.params.startDate) { obj.start_date =  this.params.startDate }
      if (this.params.endDate) { obj.end_date =  this.params.endDate }

      try {
        this.items = await Invoice.all(obj)
        this.totalItems = this.items.pagination.total_objects
      } catch (e) {
        this.handleErr(e)
      }
      this.loading = false
    },

    async downloadInvocie(invoice) {
      try {
        const data = await Invoice.download(invoice.id)
        this.downloadFile(data, `${invoice.id}.zip`)
      } catch (err) {
        this.handleErr(err)
      }
    },

    downloadFile (data, filename) {
      const url = window.URL.createObjectURL(new Blob([data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
  },

  watch: {
    pagination: {
      handler () {
        this.fetch()
      },
    },

    invoicesToken () {
      this.fetch()
    },
  },

  mounted () {
  }
}
</script>
